import { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { get_expense_category } from "../features/expense/expenseCategoryService"; // Ensure this import is correct
import CategoryToolBar from "../components/daily-expense-category/categoryToolBar";
import CategoryTable from "../components/daily-expense-category/categoryTable";
import AddNewCategoryModal from "../components/daily-expense-category/addNewCategoryModal";


const ExpenseCategory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [catData, setCatData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [reloadCategory, setReloadCategory] = useState(false);
  const [search, setSearch] = useState("");

  // Pagination states
  const [page, setPage] = useState(0); // 0-indexed page
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const getCategory = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await get_expense_category({
        page: page + 1,
        limit: rowsPerPage,
        search: search.trim(), // PASS SEARCH HERE
      });
  
      setCatData(res?.data?.expense_categories || []);
      setTotalCount(res?.data?.total || 0);
    } catch (error: any) {
      console.error("Error fetching expense categories:", error);
    } finally {
      setIsLoading(false);
    }
  }, [page, rowsPerPage, search]); // DEPENDENCY: search
  
  useEffect(() => {
    getCategory();
  }, [getCategory, reloadCategory]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  return (
    <Box sx={{ flexGrow: 1, px: 1 }}>
      {/* <Box sx={{ fontSize: "22px", lineHeight: "24px", fontWeight: 500, color: "#0B2238", paddingTop: "20px", paddingBottom: "15px" }}>
        Expense Category
      </Box> */}
      <Box sx={{ bgcolor: "white", my: "1.2%", minHeight: "80vh", px: 2, py: 0.5 }}>
        <Box>
        <CategoryToolBar
  setReloadCategory={setReloadCategory}
  search={search}
  setSearch={setSearch}
  setPage={setPage}
/>

        </Box>

        <CategoryTable
          catData={catData}
          setReloadCategory={setReloadCategory}
          page={page}
          rowsPerPage={rowsPerPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          isPagination={false} 
        />

        {openModal && <AddNewCategoryModal handleClose={handleCloseModal} setReloadCategory={setReloadCategory} />}
      </Box>
    </Box>
  );
};

export default ExpenseCategory;